export const karmaKeys = {
  all: ['karma'] as const,
  total: (days?: number) => [...karmaKeys.all, 'total', days ?? 'all'] as const,
  events: (limit: number) => [...karmaKeys.all, 'events', limit] as const,
  chart: (days: number, granularity: string) =>
    [...karmaKeys.all, 'chart', days, granularity] as const,
};
